import React, { useEffect, useState } from 'react';
import { Table, Button, Icon } from '@ds/ui';
import { KeyPairInfo } from '../../types/KeyPairInfo';

interface KeyPairProps {
  keyPairInfo: KeyPairInfo | null;
  setKeyPairInfo: (info: KeyPairInfo | null) => void;
}

export const KeyPair: React.FC<KeyPairProps> = ({ keyPairInfo, setKeyPairInfo }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isMoreDetailsOpen, setIsMoreDetailsOpen] = useState<boolean>(false);

  useEffect(() => {
    fetchKeyPairInfo();
  }, []);

  const fetchKeyPairInfo = async () => {
    try {
      const response = await fetch('Admin/Home/GetKeyPairInfo');
      const data = await response.json();
      // Parse the nested JSON string in thumbprint
      const keyPairInfoWithParsedThumbprint = {
        ...data.keyPairInfo,
        thumbprint: JSON.parse(data.keyPairInfo.thumbprint)
      };
      setKeyPairInfo(keyPairInfoWithParsedThumbprint as KeyPairInfo);
    } catch (err) {
      setError('Failed to fetch key pair info');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <span>Loading key pair info...</span>;
  if (error || !keyPairInfo) return <span>Error: {error}</span>;

  return (
    <>
      <Table columnSettings={[
        { alignment: 'left', width: '10rem'},
        { alignment: 'left', width: '3.125rem' },
        { alignment: 'left', width: '12.5rem' },
        { alignment: 'left', width: '12.5rem' }, 
      ]}>
        <Table.Body>
          {!isMoreDetailsOpen && (
              <Table.Row _style={{ padding: 0 }}>
              <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, paddingLeft: 0, fontSize: '1rem'  }}>
                      {keyPairInfo?.thumbprint.Thumbprint} 
                    </Table.Cell>
                      <button 
                      onClick={() => {
                        setIsMoreDetailsOpen(prev => !prev)}}
                      style={{
                        background: 'none',
                        border: 'none',
                        paddingLeft: '0.5rem',
                        paddingTop: '0.25rem',
                        paddingBottom: '0.5rem',   
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <Icon kind="chevronDown" size={16} />
                    </button>
                    
                  </Table.Row>
                    )}
          {isMoreDetailsOpen && (
            <>




          <Table.Row _style={{ padding: 0 }}>
            <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, paddingLeft: 0, fontSize: '1rem', fontWeight: 500 }}>Identifier</Table.Cell>
            <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, fontSize: '1rem'  }}>
              {keyPairInfo?.thumbprint.Thumbprint} 
            </Table.Cell>
              <button 
              onClick={() => {
                setIsMoreDetailsOpen(prev => !prev)}}
              style={{
                background: 'none',
                border: 'none',
                paddingLeft: '0.5rem',
                paddingTop: '0.25rem',
                paddingBottom: '0.5rem',   
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Icon kind="chevronDown" size={16} />
            </button>
            
          </Table.Row>

          <Table.Row _style={{ padding: 0 }}>
            <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, paddingLeft: 0, fontWeight: 500 }}>Expiration</Table.Cell>
            <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, fontSize: '1rem'  }}>
            {keyPairInfo?.thumbprint.ExpirationDate} 
            </Table.Cell>
          </Table.Row>
          <Table.Row _style={{ padding: 0 }}>
            <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, paddingLeft: 0, fontWeight: 500 }}>Subject</Table.Cell>
            <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, fontSize: '1rem'  }}>
            {keyPairInfo?.thumbprint.Subject} 
            </Table.Cell>
          </Table.Row>

          <Table.Row _style={{ padding: 0 }}>
            <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, paddingLeft: 0, fontWeight: 500 }}>Self-signed</Table.Cell>
            <Table.Cell _style={{ verticalAlign: 'top', paddingTop: 0, fontSize: '1rem'  }}>
            {keyPairInfo?.thumbprint.IsSelfSigned ? 'Yes' : 'No'} 
            </Table.Cell>
              </Table.Row>
            </>
          )}
        </Table.Body>
      </Table>
      </>
  );
}; 